import profileContainer from './profile.container.html';
import overviewTemplate from './overview/profile.overview.html';
import notificationsTemplate from '../notifications/notifications.list.html';
import profileContainerCtrl from './ProfileContainerController';
import overviewCtrl from './overview/ProfileOverviewController';
import preferencesCtrl from './preferences/ProfilePreferencesController';
import notificationsCtrl from '../notifications/NotificationsListController';
import preferencesTemplate from './preferences/profile.preferences.html';
import notificationCtrl from '../notifications/NotificationEditorController';
import NotificationDeleteDrawerCtrl from '../notifications/delete-drawer/NotificationDeleteDrawerController';
import groupNotificationsTemplate from '../notifications/notification.editor.html';

const module = angular.module('websked.profile', []);

const toLoad = [
  profileContainerCtrl,
  overviewCtrl,
  notificationsCtrl,
  preferencesCtrl,
  notificationCtrl,
  NotificationDeleteDrawerCtrl
];

toLoad.forEach(fn => fn(module));

function routes($urlRouterProvider, $stateProvider) {
  $stateProvider
    .state('profile', {
      abstract: true,
      url: '/profile',
      template: profileContainer,
      controller: 'ProfileContainerController'
    })
    .state('profile.overview', {
      url: '',
      template: overviewTemplate,
      controller: 'ProfileOverviewController',
      data: {
        pageTitle: {
          de: 'Mein Profil',
          en: 'My Profile',
          es: 'Mi Perfil',
          fr: 'Mon Profil'
        }
      }
    })
    .state('profile.notifications', {
      url: '/notifications',
      template: notificationsTemplate,
      controller: 'NotificationsListController',
      data: {
        pageTitle: {
          de: 'Meine Benachrichtigungen',
          en: 'My Notifications',
          es: 'Mis Notificaciones',
          fr: 'Mes Notifications'
        }
      }
    })
    .state('profile.createnotification', {
      url: '/notifications/create',
      template: groupNotificationsTemplate,
      controller: 'NotificationEditorController',
      params: {
        notificationId: null,
        clone: false
      },
      data: {
        pageTitle: {
          de: 'Benachrichtigung Erstellen',
          en: 'Create Notification',
          es: 'Crear Notificación',
          fr: 'Créer Notification'
        }
      }
    })
    .state('profile.editnotification', {
      url: '/notifications/update/:notificationId',
      template: groupNotificationsTemplate,
      controller: 'NotificationEditorController',
      data: {
        pageTitle: {
          de: 'Benachrichtigung Bearbeiten',
          en: 'Edit Notification',
          es: 'Editar Notificación',
          fr: 'Modifier Notification'
        }
      }
    })
    .state('profile.preferences', {
      url: '/preferences',
      template: preferencesTemplate,
      controller: 'ProfilePreferencesController',
      data: {
        pageTitle: {
          de: 'Meine Präferenzen',
          en: 'My Preferences',
          es: 'Mis Preferencias',
          fr: 'Mes Préférences'
        }
      }
    });
}

module.config([
  '$urlRouterProvider',
  '$stateProvider',
  routes
]);
